import { useMutation } from "@tanstack/react-query";
import { triggerNotification } from "components/TheComponents/Notification";
import { useAppContext } from "contexts";
import { ExceptionHandlingType } from "types/apiServiceTypes";
import { getErrorMessageFromResponse } from "helpers/apiHelpers";

export function useUpdateSiteRewardMutation({ onHandleSuccess }: { onHandleSuccess?: () => void }) {
  const { apiService } = useAppContext();

  return useMutation({
    mutationFn: async ({ formData, otp, id }: { formData: FormData; otp: string; id: string }) => {
      const response = await apiService.form(
        `/site-rewards/${id}`,
        formData,
        ExceptionHandlingType.MANUAL,
        { method: "PUT", headers: { "x-otp": otp } }
      );
      return response;
    },
    onSuccess: () => {
      triggerNotification({ text: "Site Reward Updated!", type: "success" });
      onHandleSuccess?.();
    },
    onError: (error) => {
      triggerNotification({ type: "error", text: getErrorMessageFromResponse(error) });
    },
  });
}
